import {
	RevokeInvitation,
	LoadInvitations,
	CreateInvitations,
	NewInvitation,
} from '../../connection/meeting';
import { ToggleInvitationType, UpdateInvitation } from '../../connection/app-entry';
import { Invitation } from '../types/invitations';
import { GetPendingJoinRequests } from '../../connection/join-request';
import { ChannelAuthMethod } from '../types/types';
import { GetInviteSsoDomains } from '../../connection/auth';
import { ProfileInterface } from '../types/user-profiles';

interface AsyncAction {
	type: string;
	promise: Promise<any>
}

export const ADD_INVITATIONS = 'ADD_INVITATIONS';
export function addInvitations(invitations: Invitation[]) {
	return {
		type: ADD_INVITATIONS,
		payload: invitations,
	};
}

export const CREATE_INVITATIONS = 'CREATE_INVITATIONS';
export function createInvitations(
	token: string,
	meeting: number,
	channelName: string,
	title: string,
	channel: number,
	invitations: NewInvitation[],
): AsyncAction {
	return {
		type: CREATE_INVITATIONS,
		promise: CreateInvitations(
			token,
			meeting,
			channelName,
			title,
			channel,
			invitations,
		),
	};
}

export const REVOKE_INVITATION = 'REVOKE_INVITATION';
export function revokeInvitation(
	token: string,
	email: string,
	channel: number,
	meeting: number,
): AsyncAction {
	return {
		type: REVOKE_INVITATION,
		promise: RevokeInvitation(token, meeting, email, channel),
	};
}

export const LOAD_INVITATIONS = 'LOAD_INVITATIONS';
export function loadInvitations(token: string, meeting: number): AsyncAction {
	return {
		type: LOAD_INVITATIONS,
		promise: LoadInvitations(token, meeting),
	};
}

export const CLEAR_INVITATIONS = 'CLEAR_INVITATIONS';
export function clearInvitations() {
	return {
		type: CLEAR_INVITATIONS,
		payload: undefined,
	};
}

export const SET_SHOULD_SEND_EMAIL = 'SET_SHOULD_SEND_EMAIL';
export function setShouldSendEmail(shouldSend: boolean) {
	return {
		type: SET_SHOULD_SEND_EMAIL,
		payload: shouldSend,
	};
}

export const SET_SHOULD_SEND_APP_PASSCODE = 'SET_SHOULD_SEND_APP_PASSCODE';
export function setShouldAppPasscode(shouldSend: boolean) {
	return {
		type: SET_SHOULD_SEND_APP_PASSCODE,
		payload: shouldSend,
	};
}

export const SET_INVITATIONS_TAB_OPEN = 'SET_INVITATIONS_TAB_OPEN';
export function setInvitationsTabOpen(open: boolean) {
	return {
		type: SET_INVITATIONS_TAB_OPEN,
		payload: open,
	};
}

export const CHANGE_INVITATION_TYPE = 'CHANGE_INVITATION_TYPE';
export function changeInvitationType(token: string, code: string, watcherOnly: boolean) {
	return {
		type: CHANGE_INVITATION_TYPE,
		promise: ToggleInvitationType(token, code, watcherOnly),
	};
}

export const ADD_JOIN_REQUEST = 'ADD_JOIN_REQUEST';
export function addJoinRequests(request: Invitation) {
	return {
		type: ADD_JOIN_REQUEST,
		payload: request,
	};
}

export const REMOVE_JOIN_REQUEST = 'REMOVE_JOIN_REQUEST';
export function removeJoinRequest(request: Invitation) {
	return {
		type: REMOVE_JOIN_REQUEST,
		payload: request,
	};
}

export const SET_JOIN_REQUEST = 'SET_JOIN_REQUEST';
export function setJoinRequest(joinRequest: number | null) {
	return {
		type: SET_JOIN_REQUEST,
		payload: joinRequest,
	};
}

export const GET_PENDING_JOIN_REQUESTS = 'GET_PENDING_JOIN_REQUESTS';
export function getPendingJoinRequests(token: string, meeting: number) {
	return {
		type: GET_PENDING_JOIN_REQUESTS,
		promise: GetPendingJoinRequests(token, meeting),
	};
}

export const UPDATE_INVITATIONS = 'UPDATE_INVITATIONS';
export function updateInvitations(invitations: Invitation) {
	return {
		type: UPDATE_INVITATIONS,
		payload: invitations,
	};
}

export const UPDATE_JOIN_REQUESTS = 'UPDATE_JOIN_REQUESTS';
export function updateJoinRequests(request: Invitation) {
	return {
		type: UPDATE_JOIN_REQUESTS,
		payload: request,
	};
}

export const REMOVE_JOIN_REQUEST_BY_EMAIL = 'REMOVE_JOIN_REQUEST_BY_EMAIL';
export function removeJoinRequestByEmail(email: string, socket: boolean = false) {
	return {
		type: REMOVE_JOIN_REQUEST_BY_EMAIL,
		payload: email,
		socket,
	};
}

export const UPDATE_INVITATION = 'UPDATE_INVITATION';
export function updateInvitation(
	token: string,
	invitationCode: string,
	isWatcherOnly: boolean,
	platformProfileId: number,
	channelId: number,
	authType: ChannelAuthMethod,
) {
	return {
		type: UPDATE_INVITATION,
		promise: UpdateInvitation(
			token,
			invitationCode,
			isWatcherOnly,
			platformProfileId,
			channelId,
			authType,
		),
	};
}

export const GET_INVITE_SSO_DOMAINS = 'GET_INVITE_SSO_DOMAINS';
export function getInviteSsoDomains(
	token: string,
	meetingId: number,
) {
	return {
		type: GET_INVITE_SSO_DOMAINS,
		promise: GetInviteSsoDomains(
			token,
			meetingId,
		),
	};
}

export const INVITE_PROFILE_EDITED = 'INVITE_PROFILE_EDITED';
export function inviteProfileEdited(message: ProfileInterface) {
	return {
		type: INVITE_PROFILE_EDITED,
		payload: message,
	};
}
